import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom'
import toast from "react-hot-toast";
import { AuthContext } from "../../AuthProvider";
import { ScreenContext } from "../../ScreenProvider";


const ERROR_MESSAGES = {
    101: "Okänd användare eller fel lösenord"
};

const Login = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const { login } = useContext(AuthContext);
    const { isMobile } = useContext(ScreenContext);

    const onLogin = (e) => {
        e.preventDefault();
        login(username, password)
            .then((user) => {
                // Signed in
                navigate("/")
            })
            .catch((error) => {
                console.log("errorcode: " + error.code);
                console.log("error: " + error);
                const message = error.code
                    ? ERROR_MESSAGES[error.code]
                    : undefined;

                toast.error(message ? message : "Ett okänt fel har uppstått");
                setUsername("");
                setPassword("");
            });

    }

    return (
        <div className={ isMobile ? "detail-container" : "login-container"}>
            <div className="card p-3 mb-3">
                <form onSubmit={onLogin}>
                    <div className="logininput">
                        <h1 className="mb-3">Logga in</h1>
                        <p className="mb-3">
                            Här loggar du in till appen Geniel för att styra och övervaka din värmepump. Har du inget konto, <a href="https://www.gronautposten.se/kontakta-oss/">kontakta oss</a> för mer information och möjlighet att beställa våra tjänster.
                        </p>
                        <label htmlFor="username">
                            E-postadress
                        </label>
                        <input
                            id="username"
                            name="username"
                            type="email"
                            required
                            placeholder="E-postadress"
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </div>

                    <div className="logininput">
                        <label htmlFor="password">
                            Lösenord
                        </label>
                        <input
                            id="password"
                            name="password"
                            type="password"
                            required
                            placeholder="Lösenord"
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    <div className="logininput text-center">
                        <button className="btn btn-primary"
                            onClick={onLogin}
                            type="submit"
                            disabled={username && password ? false : true}
                        >
                            Logga in
                        </button>
                    </div>
                    <div>
                        Problem med att logga in? <a href="https://www.gronautposten.se/kontakta-oss/">Kontakta oss</a>
                    </div>
                </form>
            </div>
        </div >

    )
}

export default Login;